// extracted by mini-css-extract-plugin
export var childrenContainer = "_da-0";
export var virtualScrollArea = "_da-1";